import React from 'react';
import { Link } from 'react-router-dom';
import './Home.css';
import atlasImg from '../images/atlas.png';
import singleCell from '../images/singlecell.png';
import mlSagittal from '../images/ML_sagittal.jpg';

class Home extends React.Component {
  render() {
    return (
      <div className="container home">
        <div className="row">
          <div className="col">
            <h2 className="text-center">Thalamus RNA-seq Atlas</h2>
            <p>On this web site, you can interactively explore gene expression in all major nuclei and
               projection systems of the mouse thalamus. You can supply lists of genes you are interested
               in, or you can perform differential gene expression tests. Any figures or data generated
               here can easily be downloaded.
            </p>
          </div>
        </div>
        <div className="row data-links">
          <div className="col-lg-6">
            <Link to="/nuclei">
              <div className="card">
                <div className="card-header">
                  Nuclei Data
                </div>
                <div className="card-body">
                  <p>Pooled-cell RNAseq for 22 thalamic nuclei</p>
                  <img alt="example atlas diagram" src={atlasImg} />
                  <button className="btn btn-primary">Explore</button>
                </div>
              </div>
            </Link>
          </div>
          <div className="col-lg-6">
            <Link to="single-cell">
              <div className="card">
                <div className="card-header">
                  Single Cell Data
                </div>
                <div className="card-body">
                  <p>Single-cell RNAseq for 5 major thalamocortical projection systems</p>
                  <img alt="example single cell plot" src={singleCell} />
                  <button className="btn btn-primary">Explore</button>
                </div>
              </div>
            </Link>
          </div>
        </div>
        <div className="row data-links">
          <div className="col-lg-6 offset-lg-3">
            <a href="http://ml-neuronbrowser.janelia.org/">
              <div className="card">
                <div className="card-header">
                  Single Cell Anatomical Reconstructions - Mouse Light
                </div>
                <div className="card-body">
                  <img alt="ML sagittal region in 3d" src={mlSagittal} /><br />
                  <button className="btn btn-primary">Explore</button>
                </div>
              </div>
            </a>
          </div>
        </div>
      </div>
    );
  }
}

export default Home;



// WEBPACK FOOTER //
// ./src/components/Home.jsx